import { LookupTable } from "./predictions-utils";

export const applyTranslation = (label?: string, translated?: string) => {
  if (translated) return `${label} (${translated})`;
  return label;
};

export const addTranslation = (
  label?: string,
  lookup?: LookupTable,
  _translation?: string,
) => {
  const translation = getTranslation(label, lookup, _translation);
  return applyTranslation(label, translation);
};

export const getTranslation = (
  label?: string,
  lookup?: LookupTable,
  _translation?: string,
) => {
  if (!label) return;
  const translation = lookup?.[label];
  const translated =
    _translation ??
    translation?.translated_name ??
    translation?.human_readable_name;
  return translated;
};
